<template>
  <div class="auth-wrapper auth-v2">
    <b-row class="auth-inner m-0">

      <!-- Left Text-->
      <b-col
        lg="8"
        class="d-none d-lg-flex align-items-center p-5"
      >
        <div class="w-100 d-lg-flex align-items-center justify-content-center px-0">
          <b-img
            fluid
            :src="imgUrl"
            alt="Login V2"
          />
        </div>
      </b-col>
      <!-- /Left Text-->

      <!-- Login-->
      <b-col
        lg="4"
        class="d-flex align-items-center auth-bg px-2 p-lg-5"
      >
        <b-col
          sm="8"
          md="6"
          lg="12"
          class="px-xl-2 mx-auto"
        >
          <b-card-title
            class="mb-1 font-weight-bold"
            title-tag="h2"
          >
            Bienvenido a <code class="text-primary bg-white" translate="no">goaligner<small>®</small></code>! 👋
          </b-card-title>

          <b-card-text class="mb-2">
            Por favor ingrese su email o usuario y contraseña para continuar
          </b-card-text>

          <!--          <b-alert
            variant="primary"
            show
          >
            <div class="alert-body font-small-2">
              <p>
                <small class="mr-50"><span class="font-weight-bold">Admin:</span> admin@demo.com | admin</small>
              </p>
              <p>
                <small class="mr-50"><span class="font-weight-bold">Client:</span> client@demo.com | client</small>
              </p>
            </div>
            <feather-icon
              v-b-tooltip.hover.left="'This is just for ACL demo purpose'"
              icon="HelpCircleIcon"
              size="18"
              class="position-absolute"
              style="top: 10; right: 10;"
            />
          </b-alert>-->

          <!-- form -->
          <validation-observer
            ref="loginForm"
            #default="{invalid}"
          >
            <b-form
              class="auth-login-form mt-2"
              @submit.prevent="login"
            >
              <!-- email -->
              <b-form-group
                label="Email / Usuario"
                label-for="login-email"
              >
                <validation-provider
                  #default="{ errors }"
                  name="Email / Usuario"
                  vid="email"
                  rules="required"
                >
                  <b-form-input
                    id="login-email"
                    v-model="userEmail"
                    :state="errors.length > 0 ? false:null"
                    name="login-email"
                    placeholder="john@example.com"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>

              <!-- forgot password -->
              <b-form-group>
                <div class="d-flex justify-content-between">
                  <label for="login-password">Contraseña</label>
                  <!--                  <b-link :to="{name:'auth-forgot-password'}">
                    <small>Forgot Password?</small>
                  </b-link>-->
                </div>
                <validation-provider
                  #default="{ errors }"
                  name="Contraseña"
                  vid="password"
                  rules="required"
                >
                  <b-input-group
                    class="input-group-merge"
                    :class="errors.length > 0 ? 'is-invalid':null"
                  >
                    <b-form-input
                      id="login-password"
                      v-model="password"
                      :state="errors.length > 0 ? false:null"
                      class="form-control-merge"
                      :type="passwordFieldType"
                      name="login-password"
                      placeholder="Contraseña"
                    />
                    <b-input-group-append is-text>
                      <feather-icon
                        class="cursor-pointer"
                        :icon="passwordToggleIcon"
                        @click="togglePasswordVisibility"
                      />
                    </b-input-group-append>
                  </b-input-group>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>

              <b-alert
                v-if="clinicLoginWarning"
                variant="info"
                show
                class="p-1"
              >
                <small>Si estás intentando ingresar como clínica. Usa tu nombre de <b>usuario y contraseña</b>.</small>
              </b-alert>

              <b-button
                type="submit"
                block
                :disabled="invalid || loading"
                :variant="loading ? 'secondary' : 'primary'"
              >
                <b-spinner
                  v-if="loading"
                  small
                  class="mr-2"
                />
                {{ loading ? 'Iniciando sesión...' : 'Inicia sesión' }}
              </b-button>

            </b-form>
          </validation-observer>

          <b-card-text class="text-center mt-2">
            <span>¿Aún no tienes cuenta? </span> <br>
            <b-link :to="{name:'auth-register-dentist'}">
              <span>&nbsp;Crea cuenta Odontologo</span>
            </b-link>
            <br>
            <div class="divider my-2">
              <div class="divider-text">
                o
              </div>
            </div>
            <b-link :to="{name:'auth-register-clinic'}">
              <span>&nbsp;Crea cuenta Clinica</span>
            </b-link>
          </b-card-text>

        </b-col>
      </b-col>
    <!-- /Login-->
    </b-row>
  </div>
</template>

<script>
/* eslint-disable global-require */
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import VuexyLogo from '@core/layouts/components/Logo.vue'
import {
  BRow,
  BCol,
  BLink,
  BFormGroup,
  BFormInput,
  BInputGroupAppend,
  BInputGroup,
  BFormCheckbox,
  BCardText,
  BCardTitle,
  BImg,
  BForm,
  BButton,
  BAlert,
  VBTooltip,
  BSpinner,
} from 'bootstrap-vue'
import useJwt from '@/auth/jwt/useJwt'
import { required, email } from '@validations'
import { togglePasswordVisibility } from '@core/mixins/ui/forms'
import store from '@/store/index'
import { getHomeRouteForLoggedInUser } from '@/auth/utils'

import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import api from '@/plugin/axios'

export default {
  directives: {
    'b-tooltip': VBTooltip,
  },
  components: {
    BSpinner,
    BRow,
    BCol,
    BLink,
    BFormGroup,
    BFormInput,
    BInputGroupAppend,
    BInputGroup,
    BFormCheckbox,
    BCardText,
    BCardTitle,
    BImg,
    BForm,
    BButton,
    BAlert,
    VuexyLogo,
    ValidationProvider,
    ValidationObserver,
  },
  mixins: [togglePasswordVisibility],
  data() {
    return {
      status: '',
      password: null,
      userEmail: null,
      sideImg: 'https://dev-goaligner.s3.us-east-1.amazonaws.com/config/images/left_side_image.jpeg',

      // validation rules
      required,
      email,
      loading: false,
      clinicLoginWarning: false,
    }
  },
  computed: {
    passwordToggleIcon() {
      return this.passwordFieldType === 'password' ? 'EyeIcon' : 'EyeOffIcon'
    },
    imgUrl() {
      if (store.state.appConfig.layout.skin === 'dark') {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.sideImg = 'https://dev-goaligner.s3.us-east-1.amazonaws.com/config/images/left_side_image.jpeg'
        return this.sideImg
      }
      return this.sideImg
    },
  },
  watch: {
    userEmail(value) {
      const isEmail = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)
      if (!isEmail) {
        this.clinicLoginWarning = true
      } else {
        this.clinicLoginWarning = false
      }
    },
  },
  methods: {
    async login() {
      this.loading = true
      try {
        const response = await api.post('/api/auth/login', {
          email: this.userEmail,
          password: this.password,
        })

        const { token, user } = response.data

        user.ability = [
          {
            action: 'manage',
            subject: 'all',
          },
        ]

        await localStorage.setItem('token', token)
        await localStorage.setItem('userData', JSON.stringify(user))

        this.$ability.update([
          {
            action: 'manage',
            subject: 'all',
          },
        ])

        this.$toast({
          component: ToastificationContent,
          position: 'top-right',
          props: {
            title: `Bienvenido ${user.full_name}`,
            icon: 'CoffeeIcon',
            variant: 'success',
            text: `Has iniciado sesión como ${user.role.name}. ¡Bienvenido!`,
          },
        })

        this.$nextTick(() => {
          this.$router.replace(getHomeRouteForLoggedInUser(user.role.name));
        });

        // this.$store.dispatch('menu/loadMenu', user.role_id)
      } catch (error) {
        console.log(error.response)
        if (error.response && error.response.data.errors) {
          const messages = Object.values(error.response.data.errors).flat().join('\n')

          this.$bvToast.toast(messages, {
            title: 'Error',
            variant: 'danger',
            solid: true,
            autoHideDelay: 5000,
          })
        } else if (error.response && error.response.data.message) {
          const messages = error.response.data.message

          this.$bvToast.toast(messages, {
            title: 'Error',
            variant: 'danger',
            solid: true,
            autoHideDelay: 5000,
          })
        } else {
          this.$bvToast.toast('Ocurrió un error inesperado.', {
            title: 'Error',
            variant: 'danger',
            solid: true,
            autoHideDelay: 5000,
          })
        }
      } finally {
        this.loading = false
      }
    },

    /* login() {
      this.$refs.loginForm.validate().then(success => {
        if (success) {
          useJwt.login({
            email: this.userEmail,
            password: this.password,
          })
            .then(response => {
              const { userData } = response.data
              useJwt.setToken(response.data.accessToken)
              useJwt.setRefreshToken(response.data.refreshToken)
              localStorage.setItem('userData', JSON.stringify(userData))
              this.$ability.update(userData.ability)

              // ? This is just for demo purpose as well.
              // ? Because we are showing eCommerce app's cart items count in navbar
              this.$store.commit('app-ecommerce/UPDATE_CART_ITEMS_COUNT', userData.extras.eCommerceCartItemsCount)

              // ? This is just for demo purpose. Don't think CASL is role based in this case, we used role in if condition just for ease
              this.$router.replace(getHomeRouteForLoggedInUser(userData.role))
                .then(() => {
                  this.$toast({
                    component: ToastificationContent,
                    position: 'top-right',
                    props: {
                      title: `Welcome ${userData.fullName || userData.username}`,
                      icon: 'CoffeeIcon',
                      variant: 'success',
                      text: `You have successfully logged in as ${userData.role}. Now you can start to explore!`,
                    },
                  })
                })
            })
            .catch(error => {
              this.$refs.loginForm.setErrors(error.response.data.error)
            })
        }
      })
    }, */
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/pages/page-auth.scss';
</style>
